import { createContext, useContext } from "react";

export const FirmUserChatContext = createContext(null);

export const hasChatUserId = (userId) =>
  (typeof userId === "number" || typeof userId === "string") &&
  Number.isSafeInteger(Number(userId)) &&
  Number(userId) > 0;

export function useFirmUserChat({ userId, disableChat, onClick, ...recipient }) {
  const openChat = useContext(FirmUserChatContext);
  const hasName = Boolean(recipient.first_name || recipient.last_name);

  if (disableChat || !hasName) return undefined;
  if (onClick) return onClick;
  if (!openChat || !hasChatUserId(userId)) return undefined;

  return (event) => {
    event.preventDefault();
    event.stopPropagation();
    openChat({ ...recipient, userId });
  };
}
